import { useSelector } from "react-redux";

import { useFirmRecord } from "@/features/lawFirms/firmQuery";
import { lawyerSelectors } from "@/redux/lawyer/selectors";

const NONE: readonly string[] = [];

/** The tab ids the signed-in lawyer's firm hides from the sidebar. */
export const useHiddenSidebarTabs = (enabled: boolean): readonly string[] => {
  const lawyer = useSelector(lawyerSelectors.selectAll);
  const lawFirmId = (lawyer?.law_firm_id ?? "").trim();
  const { data } = useFirmRecord(lawFirmId, enabled);
  return data?.hidden_sidebar_tabs ?? NONE;
};
